import { useState, useEffect } from 'react';
import {
  APP_LANGUAGE_STORAGE_KEY,
  appLanguageToHtmlLang,
  resolveInitialAppLanguage,
} from '@/core/i18n/i18n';

export function useUserSettings() {
  const [language, setLanguage] = useState<'en' | 'pl'>(resolveInitialAppLanguage);
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    const storedTheme = localStorage.getItem('app_theme');
    return (storedTheme === 'light' || storedTheme === 'dark') ? storedTheme : 'light';
  });

  // Persist language setting
  useEffect(() => {
    try {
      localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, language);
    } catch {
      /* ignore */
    }
    document.documentElement.lang = appLanguageToHtmlLang(language);
  }, [language]);

  // Persist theme setting
  useEffect(() => {
    localStorage.setItem('app_theme', theme);
    document.documentElement.className = theme; // Apply theme to root html element
  }, [theme]);

  return {
    language,
    setLanguage,
    theme,
    setTheme,
  };
}
